import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux"

import LoadingComponent from '../components/core/LoadingComponent';
import { ABHIIframeLogin } from '../utils/API';
import get from 'lodash.get';
import { Alert, Container, Grid } from '@mui/material';
import { login } from '../store/slices/AuthSlice';


const Iframe = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dataParam = searchParams.get('data');

  const [errorMessage, setErrorMessate] = useState("")

  useEffect(() => {
    (async () => {
      console.log("Iframe is called")
      let response = await ABHIIframeLogin(dataParam)
      if (!get(response, ['data', 'success'], false)) {
        setErrorMessate(get(response, ['data', 'message', 'text'], 'Something went wrong'))
      }
      else {
        dispatch(
          login({
            email: get(response, ['data', 'data', 'jarvisUserId'], 0),
            token: get(response, ['data', 'data', 'token'], 0),
            role: get(response, ['data', 'data', 'role'], 0),
          })
        )
        navigate(`/claim/${get(response, ['data', 'data', 'claimId'], 0)}`)
      }
    })();
  }, [])

  if (errorMessage.length > 0) {
    return (
      <>
        <Container style={{ padding: 16, width: "40rem", marginTop: "9rem" }}>
          <Alert severity="error">
            <Grid>
              <h1>Oops ! </h1>
              <h3>{errorMessage}</h3>
              {/* <a href={'/'}>Click here to go back</a> */}
            </Grid>
          </Alert>
        </Container>
      </>
    )
  }

  return (
    <LoadingComponent />
  )
}

export default Iframe